import React, {useEffect, useState} from "react";
import HamburguerBtn from "../../HamburguerBtn/HamburguerBtn";
import {Image} from "react-bootstrap";
import logoIfh from "../../../assets/images/ifh-logo.png";
import style from "./MobileSideBar.module.css";

const MobileSideBar = ({ sidebarExpanded, setSidebarExpanded, children }) => {
    const [role, setRole] = useState("");
    const userRole = sessionStorage.getItem("userRole");

    useEffect(()=>{
        if(userRole === "1"){
            setRole("Admin");
        }else if(userRole === "2"){
            setRole("Alumno");
        }else if(userRole === "3"){
            setRole("Profesor");
        }else{
            setRole("");
        }
    }, [userRole]);

    const handleOffCanvas = () => {
        setSidebarExpanded(!sidebarExpanded);
    }

    const header =
        <div className={style.header}>
            <div className={style.hamburgerButtonContainer}>
                <HamburguerBtn clicked={sidebarExpanded} handleOffcanvas={handleOffCanvas}/>
            </div>
            <div>
                <Image className={style.image} src={logoIfh}/>
            </div>
        </div>

    const sideBar =
            <div className={style.sideBar}>
                {/* close button */}
                <div className={style.closeButtonContainer}>
                    <HamburguerBtn clicked={sidebarExpanded} handleOffcanvas={handleOffCanvas}/>
                </div>
                {/* logo */}
                <div className={style.logoContainer}>
                    <Image className={style.logo} src={logoIfh} />
                </div>

                {/* rol */}
                <div>{role &&
                    <p className={style.profileText}>Perfil: {role}</p>}
                </div>

                {/* Botones */}
                {children}
            </div>

    return (
        <>
            {sidebarExpanded &&
                <>
                    {sideBar}
                </>
            }
            {sidebarExpanded &&
                <div
                    onClick={handleOffCanvas}
                    className={style.backgroundOverlay}
                />
            }
            {header}
        </>
    )
}

export default MobileSideBar
